import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { View, Image, TouchableOpacity } from 'react-native';
import { STYLE_VARS } from '../../../constants/style-vars';
import { Text } from '../../../components/Text/Text';
import { Button } from '../../../components/Button';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { RootState } from '../../../services/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import Swiper from 'react-native-web-swiper';
import { COLORS, FONTS } from '../../../constants';
import { NavigationService } from '../../../services/navigation';
import { IPromotion } from '../../../types/promotions.types';
import { PromotionsApi } from '../../../services/api';

const LOREM =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';

function extractSrcFromHtml(htmlString: string): string | null {
  const imgRegex = /<img.*?src=['"](.*?)['"]/i;
  const match = htmlString.match(imgRegex);
  const src = match ? match[1] : null;
  return src;
}

export const Promotions: FC = () => {
  const isDesktop = useIsDesktop();
  const auth = useSelector((redux: RootState) => redux.authReducer);
  const [promotions, setPromotions] = useState<IPromotion[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getPromotions = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await PromotionsApi.getPromotions({});
      setPromotions(res.data.promotions);
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    getPromotions();
  }, [getPromotions]);

  // const { promotions, isLoading } = useSelector(
  //   (state: RootState) => state?.promotionReducer
  // );

  const renderSwiper = useMemo(() => {
    if (promotions && promotions.length > 0) {
      return (
        <Swiper
          controlsProps={{
            prevPos: false,
            nextPos: false,
            DotComponent: () => <></>,
          }}
          timeout={isDesktop() ? 15 : 5}
          loop
        >
          {promotions.map((promotion) => (
            <View key={promotion.id}>
              <TouchableOpacity
                onPress={() => {
                  NavigationService.push<'DinningPromotionDetail'>(
                    'DinningPromotionDetail',
                    {
                      id: promotion.id,
                    }
                  );
                }}
              >
                <Image
                  style={{
                    width: '100%',
                    height: isDesktop() ? 120 : 170,
                    resizeMode: 'cover',
                  }}
                  source={{ uri: promotion.thumb ? promotion.thumb : '' }}
                />
              </TouchableOpacity>
              <Text
                style={{
                  textAlign: 'center',
                  fontSize: 15,
                  color: STYLE_VARS.primaryColor,
                  marginVertical: 20,
                  fontFamily: FONTS.IowanOldStyleBTRoman,
                  textTransform: 'uppercase',
                }}
                onPress={() => {
                  NavigationService.push<'DinningPromotionDetail'>(
                    'DinningPromotionDetail',
                    {
                      id: promotion.id,
                    }
                  );
                }}
              >
                {promotion.title}
              </Text>
              <View style={{ alignSelf: 'center' }}>
                <Button
                  text="READ MORE"
                  style={STYLE_VARS.blueButton}
                  onPress={() => {
                    NavigationService.push<'DinningPromotionDetail'>(
                      'DinningPromotionDetail',
                      {
                        id: promotion.id,
                      }
                    );
                  }}
                />
              </View>
            </View>
          ))}
        </Swiper>
      );
    } else {
      return (
        <View
          style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}
        >
          <Text
            style={{
              fontSize: 20,
              color: STYLE_VARS.textColor,
            }}
          >
            {isLoading ? 'LOADING ...' : 'COMMING SOON'}
          </Text>
        </View>
      );
    }
  }, [promotions, isDesktop, isLoading]);

  return (
    <View style={{ flexDirection: 'column', width: '100%', marginTop: 30 }}>
      <View style={{ flexDirection: 'column' }}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {isDesktop() && (
            <View
              style={{
                width: 60,
                height: 1,
                marginRight: 3,
                backgroundColor: STYLE_VARS.primaryColor,
              }}
            />
          )}

          <Text
            style={{
              fontFamily: FONTS.IowanOldStyleBTRoman,
              color: STYLE_VARS.primaryColor,
              textAlign: 'center',
            }}
          >
            DINING
          </Text>
          {isDesktop() && (
            <View
              style={{
                width: 60,
                height: 1,
                marginRight: 3,
                backgroundColor: STYLE_VARS.primaryColor,
              }}
            />
          )}
        </View>
        <Text
          style={{
            fontFamily: FONTS.IowanOldStyleBTRoman,
            fontSize: 24,
            color: STYLE_VARS.primaryColor,
            textAlign: 'center',
            marginBottom: 20,
          }}
          onPress={() => {
            if (auth.loggedin === true) {
              NavigationService.push<'Root'>('Root', {
                screen: 'MenuTab',
                params: {
                  screen: 'DinningPromotion',
                },
              });
            } else {
              NavigationService.push('DinningPromotion');
            }
          }}
        >
          PROMOTION
        </Text>
      </View>
      <View style={{ width: '100%', height: 300 }}>{renderSwiper}</View>
    </View>
  );
};
